export default __webpack_public_path__ + "static/media/BANNER-FULL_Covid_03_Sanguineo.ee628909.png";